<body>
    <router-outlet></router-outlet>
</body>
